import { render, staticRenderFns } from "./korToMasCoupon.vue?vue&type=template&id=59825a88&scoped=true&"
import script from "./korToMasCoupon.vue?vue&type=script&lang=js&"
export * from "./korToMasCoupon.vue?vue&type=script&lang=js&"
import style0 from "./korToMasCoupon.vue?vue&type=style&index=0&id=59825a88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59825a88",
  null
  
)

export default component.exports